import { MuiComponent } from "./type"
import * as Colors from "../colors"

export const MuiTabs: MuiComponent<"MuiTabs"> = {
  defaultProps: {
    TabIndicatorProps: {
      style: {
        backgroundColor: Colors.ActiveTab
      }
    },
  },
  styleOverrides: {
    root: {
      borderBottom: `1px solid ${Colors.TabDivider}`,
    },
    flexContainer: {
      gap: '20px',
    },
  },
};

export const MuiTab: MuiComponent<"MuiTab"> = {
  styleOverrides: {
    root: {
      color: Colors.Tabs,
      textTransform: 'none',
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 500,
      paddingBottom: 16,
      paddingLeft: 0,
      paddingRight: 0,
      minWidth: 'auto',
      width: 'auto',

      '&.Mui-selected': {
        color: Colors.ActiveTab,
      },
    },
  },
};
